var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"header"},[_c('BottomText')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }